<script>
  import Icon from "./Icon.svelte";
  import { topFourDepartments } from "@stores/userData.js";
  import departmentBudgets from "@data/departmentBudgets.json";

  let index = 0;
  export let active;

  $: currentDepartment = $topFourDepartments[index];
  $: budget = departmentBudgets.find(
    (d) => d.name === currentDepartment.Department
  )?.budget;

  // Function to turn string into sentence case
  const sentenceCase = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  // Split the 'Services' value into a list of items
  $: responsibilities = currentDepartment.Services.split(",").map((d) =>
    sentenceCase(d.trim())
  );

  const increment = () => {
    index++;
    if (index >= $topFourDepartments.length - 1) {
      index = 0;
    }
  };

  import { format } from "d3-format";
  const suffixFormat = format(",.3s");
</script>

<button tabindex={active ? 0 : -1} on:click={increment}>Change</button>

<div class="shareable-card">
  <h1>In FY23, I want more funding for...</h1>
  <div class="dept">
    <h2>{currentDepartment.Department}</h2>
    <h3>Current budget: ${suffixFormat(budget)}</h3>
  </div>

  <div class="goals">
    <ul>
      {#each responsibilities as responsibility}
        <li>{responsibility}</li>
      {/each}
    </ul>
  </div>

  <span class="shareable-card-footer"
    >Make your voice heard at <strong>houstonbudget.cool</strong></span
  >
  <div class="icon-container">
    <Icon src="{currentDepartment.Department}.png" />
  </div>
</div>

<style>
  h1 {
    position: absolute;
    width: 100%;
    top: 7%;
    left: 1.5vw;
    font-size: 4.5vw;
    font-weight: 200;
    line-height: 1.15;
    text-align: left;
  }

  .dept {
    line-height: 1.15;
    position: absolute;
    top: 30%;
    left: 1.5vw;
    font-weight: bold;
    text-align: left;
    width: 95%;
  }

  .dept h2 {
    font-size: 4.5vw;
    line-height: 1;
    margin-bottom: 0.5vw;
  }

  .dept h3 {
    font-size: 3vw;
    text-transform: uppercase;
    font-weight: 400;
  }

  .goals {
    position: absolute;
    top: 60%;
    left: 4vw;
    text-align: left;
  }

  li {
    list-style-type: circle;
    margin-bottom: 1vw;
    font-size: 2.5vw;
    font-weight: 200;
  }

  .icon-container {
    max-width: 10vw;
    position: absolute;
    right: 1.5vw;
    top: 1vh;
  }

  button {
    pointer-events: all;
    z-index: 0;
    position: absolute;
    bottom: -2.15rem;
    right: 0;
    padding: 0.5rem 1rem 0.45rem 1rem;
    border: 1px solid var(--accent-color);
    cursor: pointer;
    background: var(--primary-color);
    font-family: var(--font-serif);
    color: var(--accent-color);
  }
</style>
